<template>
  <div class="switcher-tabs">
    <div
      v-for="(tab, index) in tabs"
      :key="tab.title"
      :class="{'switcher-tabs__item--active': index === activeIndex}"
      class="switcher-tabs__item transition--color-bg"
      @click="emitInput(index)">
      {{ tab.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitcherTabs',

  props: {
    tabs: {
      type: Array,
      required: true,
    },

    value: {
      type: [Number, String],
      required: false,
    },

    mode: {
      type: String,
      required: false,
      default: 'default',
      validator: (value) => (['default', 'currency'].includes(value)),
    },
  },

  computed: {
    activeIndex() {
      if (this.mode === 'currency') {
        return this.tabs.findIndex((tab) => tab.title === this.value);
      }

      return this.value;
    },
  },

  methods: {
    emitInput(index) {
      if (this.mode === 'currency') {
        this.$emit('input', this.tabs[index].title);
        return;
      }

      this.$emit('input', index);
    },
  },
};
</script>

<style lang="scss" scoped>
  .switcher-tabs {
    --background-color: #{rgba($color--basic-blue, 0.25)};
    --border-width: 2px;
    --border-radius: 4px;
    --font-weight: 500;
    --font-size: 1em;
    --text-align: center;
    --container-padding: 7px;
    --button-padding: 8px 16px;

    border: var(--border-width) solid var(--background-color);
    border-radius: var(--border-radius);
    padding: var(--container-padding);
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr);
  }

  .switcher-tabs__item {
    cursor: pointer;
    font-size: var(--font-size);
    font-weight: var(--font-weight);
    text-align: var(--text-align);
    padding: var(--button-padding);
    border-radius: var(--border-radius);
    display: flex;
    align-items: center;
    justify-content: center;

    &--active {
      background-color: var(--background-color);
    }
  }
</style>
